export default __webpack_public_path__ + "right-arrow-in-a-circle.png";